import { type ComponentType, createContext, useContext } from 'react';
import type { WixRicosViewerProps } from '@wix/ricos';

export const WixRicosViewerContext = createContext<
  ComponentType<WixRicosViewerProps> | undefined
>(undefined);

export function useWixRicosViewer() {
  const context = useContext(WixRicosViewerContext);
  if (context === undefined) {
    throw new Error(
      'useWixRicosViewer must be used within a WixRicosViewerContext.Provider',
    );
  }

  return context;
}
